import { createSlice } from '@reduxjs/toolkit';
import {
  createCompanyDetails,
  fetchActiveCompanyForUser,
  fetchCompanyDetails,
  fetchCompanyDetailsById,
  updateCompanyDetails,
} from './companyDetailsActions';
import { CompanyDetailsState } from './companyDetailsTypes';

const initialState: CompanyDetailsState = {
  companyDetails: [],
  selectedCompany: null,
  activeCompany: null, 
  fetchLoading: false,
  fetchError: undefined,
  updateLoading: false,
  updateError: undefined,
  createLoading: false,
  createError: undefined,
};

const companyDetailsSlice = createSlice({
  name: 'companyDetails',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Fetch Company Details
    builder
      .addCase(fetchCompanyDetails.pending, (state) => {
        state.fetchLoading = true;
        state.fetchError = undefined;
      })
      .addCase(fetchCompanyDetails.fulfilled, (state, action) => {
        state.fetchLoading = false;
        state.companyDetails = action.payload.data;
      })
      .addCase(fetchCompanyDetails.rejected, (state, action) => {
        state.fetchLoading = false;
        state.fetchError = action.payload as string;
      });

    // Update Company Details
    builder
      .addCase(updateCompanyDetails.pending, (state) => {
        state.updateLoading = true;
        state.updateError = undefined;
      })
      .addCase(updateCompanyDetails.fulfilled, (state) => {
        state.updateLoading = false;
      })
      .addCase(updateCompanyDetails.rejected, (state, action) => {
        state.updateLoading = false;
        state.updateError = action.payload as string;
      })
    builder
      .addCase(fetchCompanyDetailsById.pending, (state) => {
        state.fetchLoading = true;
        state.fetchError = undefined;
      })
      .addCase(fetchCompanyDetailsById.fulfilled, (state, action) => {
        state.fetchLoading = false;
        state.selectedCompany = action.payload.data;
      })
      .addCase(fetchCompanyDetailsById.rejected, (state, action) => {
        state.fetchLoading = false;
        state.fetchError = action.payload as string;
      })
      builder
      .addCase(createCompanyDetails.pending, (state) => {
        state.createLoading = true;
        state.createError = undefined;
      })
      .addCase(createCompanyDetails.fulfilled, (state) => {
        state.createLoading = false;
      })
      .addCase(createCompanyDetails.rejected, (state, action) => {
        state.createLoading = false;
        state.createError = action.payload as string;
      });
      builder
      .addCase(fetchActiveCompanyForUser.pending, (state) => {
        state.fetchLoading = true;
        state.fetchError = undefined;
      })
      .addCase(fetchActiveCompanyForUser.fulfilled, (state, action) => {
        state.fetchLoading = false;
        state.activeCompany = action.payload.data;
      })
      .addCase(fetchActiveCompanyForUser.rejected, (state, action) => {
        state.fetchLoading = false;
        state.fetchError = action.payload as string;
      });
  },
});

export default companyDetailsSlice.reducer;
